

RCAdminTransactionsController.$inject = ["$stateParams"];

export default function RCAdminTransactionsController($stateParams) {
  var vm = this;

  vm.searchText = $stateParams.q;
}
